import { Component, Fragment } from "react";
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";

/* ================= BLOG DATA ================= */

let BlogContentListOne = [
    {
        imgUrl: 'assets/images/blog/blog1.jpg',
        imgAlt: 'Trackmania World Cup 2025',
        title: 'Trackmania World Cup 2025: The Last Drift Begins!',
        desc: 'The road has been long and unforgiving, and now only four teams remain for the Trackmania World Cup 2025 Finals at Paris Games Week.',
        btnText: 'read more',
        pubDate: '26 Oct 2025',
        pubAuthor: 'Trackmania',
        externalUrl: 'https://www.trackmania.com/news/8810'
    },
];

let BlogContentListTwo = [
    {
        imgUrl: 'assets/images/blog/blog2.jpg',
        imgAlt: 'Trackmania Global Playoffs #2',
        title: 'TMWT2025: Global Playoffs #2 – Road to the World Cup',
        desc: 'The Global Playoffs #2 bring together the top 16 duos competing for four remaining World Cup spots.',
        btnText: 'read more',
        pubDate: '02 Oct 2025',
        pubAuthor: 'Trackmania',
        externalUrl: 'https://www.trackmania.com/news/8788'
    },
    {
        imgUrl: 'assets/images/blog/blog3.jpg',
        imgAlt: 'Trackmania World Cup 2025 Photos',
        title: 'Trackmania World Cup 2025 Photos Gallery',
        desc: 'Relive the biggest moments from Paris Games Week through the official World Cup photo gallery.',
        btnText: 'read more',
        pubDate: '06 Nov 2025',
        pubAuthor: 'Trackmania',
        externalUrl: 'https://www.trackmania.com/news/8898'
    },
];

let BlogContentListThree = [

    {
        imgUrl: 'assets/images/blog/blog4.png',
        imgAlt: 'BIG Trackmania Cup',
        title: 'BIG TRACKMANIA CUP',
        desc: 'A massive community tournament with a €10,000 prize pool and global participation.',
        btnText: 'read more',
        pubDate: '05 Dec 2025',
        pubAuthor: 'Trackmania',
        externalUrl: 'https://www.trackmania.com/news/8920'
    },
    {
        imgUrl: 'assets/images/blog/blog5.png',
        imgAlt: 'Join the Trackmania Games',
        title: 'Join the Trackmania Games',
        desc: 'A nation-based Trackmania competition running from January to February 2026.',
        btnText: 'read more',
        pubDate: '05 Dec 2025',
        pubAuthor: 'Trackmania',
        externalUrl: 'https://www.trackmania.com/news/8913'
    },
];

/* ================= BLOG PAGE ================= */

class BlogPage extends Component {
    render() {
        return (
            <Fragment>
                <Header />
                

                <div className="blog-section padding-top padding-bottom">
                    <div className="blog-glow-center">
                        <span className="blob-orange"></span>
                        <span className="blob-green"></span>
                    </div>
                    <div className="container">
                        <div className="section-wrapper">
                            <div className="row g-4 justify-content-center">

                                {/* FEATURED BLOG */}
                                {BlogContentListOne.map((val, i) => (
                                    <div className="col-12" key={i}>
                                        <div className="blog-item fade-up fade-delay-2">
                                            <div className="blog-inner d-flex flex-wrap align-items-center">
                                                <div className="blog-thumb w-xl-50 w-100">
                                                    <a href={val.externalUrl} target="_blank" rel="noopener noreferrer">
                                                        <img src={val.imgUrl} alt={val.imgAlt} className="w-100" />
                                                    </a>
                                                </div>
                                                <div className="blog-content p-4 w-xl-50 w-100">
                                                    <a href={val.externalUrl} target="_blank" rel="noopener noreferrer">
                                                        <h3>{val.title}</h3>
                                                    </a>
                                                    <div className="meta-post">
                                                        <span>{val.pubAuthor}</span>
                                                        <span>{val.pubDate}</span>
                                                    </div>
                                                    <p>{val.desc}</p>
                                                    <a
                                                        href={val.externalUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="default-button"
                                                    >
                                                        <span>{val.btnText} <i className="icofont-circled-right"></i></span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {/* TWO COLUMN BLOGS */}
                                {BlogContentListTwo.map((val, i) => (
                                    <div className="col-lg-6 col-12" key={i}>
                                        <div className="blog-item fade-up fade-delay-2">
                                            <div className="blog-inner">
                                                <div className="blog-thumb">
                                                    <a href={val.externalUrl} target="_blank" rel="noopener noreferrer">
                                                        <img src={val.imgUrl} alt={val.imgAlt} className="w-100" />
                                                    </a>
                                                </div>
                                                <div className="blog-content px-3 py-4">
                                                    <a href={val.externalUrl} target="_blank" rel="noopener noreferrer">
                                                        <h3>{val.title}</h3>
                                                    </a>
                                                    <div className="meta-post">
                                                        <span>{val.pubAuthor}</span>
                                                        <span>{val.pubDate}</span>
                                                    </div>
                                                    <p>{val.desc}</p>
                                                    <a
                                                        href={val.externalUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="default-button reverse-effect"
                                                    >
                                                        <span>{val.btnText} <i className="icofont-circled-right"></i></span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {/* GRID BLOGS */}
                                {BlogContentListThree.map((val, i) => (
                                    <div className="col-xl-4 col-md-6 col-12" key={i}>
                                        <div className="blog-item fade-up fade-delay-2">
                                            <div className="blog-inner">
                                                <div className="blog-thumb">
                                                    <a href={val.externalUrl} target="_blank" rel="noopener noreferrer">
                                                        <img src={val.imgUrl} alt={val.imgAlt} className="w-100" />
                                                    </a>
                                                </div>
                                                <div className="blog-content px-3 py-4">
                                                    <a href={val.externalUrl} target="_blank" rel="noopener noreferrer">
                                                        <h3>{val.title}</h3>
                                                    </a>
                                                    <div className="meta-post">
                                                        <span>{val.pubAuthor}</span>
                                                        <span>{val.pubDate}</span>
                                                    </div>
                                                    <p>{val.desc}</p>
                                                    <a
                                                        href={val.externalUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="default-button"
                                                    >
                                                        <span>{val.btnText} <i className="icofont-circled-right"></i></span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </Fragment>
        );
    }
}

export default BlogPage;
